import React, { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { FileText, RotateCcw, Pencil } from 'lucide-react';

const BACKEND_URL = '';

export function AdminAuditTab() {
  const [auditEntries, setAuditEntries] = useState([]);
  const [auditTotal, setAuditTotal] = useState(0);

  const loadAuditTrail = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/admin/edit-audit-trail?limit=50`, { credentials: 'include' });
      if (res.ok) { const data = await res.json(); setAuditEntries(data.entries || []); setAuditTotal(data.total || 0); }
    } catch {}
  };

  return (
    <div className="space-y-4" data-testid="admin-audit-content">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-xl font-bold font-heading">Edit Audit Trail</h2>
        <Button size="sm" variant="outline" onClick={loadAuditTrail} data-testid="refresh-audit-btn">
          <RotateCcw className="h-3.5 w-3.5 mr-1.5" /> Refresh
        </Button>
      </div>
      <p className="text-sm text-slate-500">Review all content edits made by users across Forum and BriteLab posts.</p>
      {auditEntries.length === 0 ? (
        <Card className="p-8 text-center">
          <FileText className="h-8 w-8 text-slate-300 mx-auto mb-2" />
          <p className="text-slate-500 text-sm">No edit history yet. Click "Refresh" to load.</p>
        </Card>
      ) : (
        <div className="space-y-3">
          {auditEntries.map(entry => (
            <Card key={entry.audit_id} className="p-4" data-testid={`audit-${entry.audit_id}`}>
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <Pencil className="h-3.5 w-3.5 text-amber-500" />
                    <span className="font-semibold text-sm text-slate-800">{entry.user_name}</span>
                    <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-slate-100 text-slate-600 font-medium uppercase">{entry.entity_type?.replace('_', ' ')}</span>
                    <span className="text-xs text-slate-400">{new Date(entry.timestamp).toLocaleString()}</span>
                  </div>
                  <div className="grid grid-cols-2 gap-3 mt-2">
                    <div className="bg-red-50/60 rounded p-2">
                      <p className="text-[10px] text-red-600 font-bold uppercase mb-1">Previous</p>
                      {entry.previous_title && <p className="text-xs font-medium text-slate-700">Title: {entry.previous_title}</p>}
                      <p className="text-xs text-slate-600 line-clamp-3">{entry.previous_content}</p>
                    </div>
                    <div className="bg-green-50/60 rounded p-2">
                      <p className="text-[10px] text-green-600 font-bold uppercase mb-1">Updated</p>
                      {entry.new_title && <p className="text-xs font-medium text-slate-700">Title: {entry.new_title}</p>}
                      <p className="text-xs text-slate-600 line-clamp-3">{entry.new_content}</p>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          ))}
          <p className="text-xs text-slate-400 text-center">Showing {auditEntries.length} of {auditTotal} entries</p>
        </div>
      )}
    </div>
  );
}
